import { Config } from 'core/common/contexts';
import { config } from 'core/config';

export const appnebulaConfig: Config = {
  ...config,
};
